export enum ThirdPartyIntegrationType {
  GOOGLE_SEARCH_CONSOLE_VERIFICATION = "google_search_console_verification",
}
